import React, { useState } from 'react';
type Plan = {
  id: 'essential' | 'elite';
  badge?: string;
  label: string;
  title: string;
  subtitle: string;
  oldPrice: string;
  price: string;
  url: string;
  highlight?: boolean;
  features: string[];
};
const PLANS: Plan[] = [{
  id: 'essential',
  label: 'Plan Esencial',
  title: 'Kit Lashista',
  subtitle: '4 Tomos + 4 Bonos',
  oldPrice: '$58.000',
  price: '$15.990',
  url: 'https://www.nexorecursos.com/cart/52544691831060:1',
  features: ['4 Tomos completos', '4 Bonos de acción inmediata', 'Acceso inmediato 100% digital']
}, {
  id: 'elite',
  badge: '⭐ Más elegido',
  label: 'Plan Élite',
  title: 'Kit + Lashista de Élite',
  subtitle: '4 Tomos + 4 Bonos + Élite',
  oldPrice: '$80.990',
  price: '$22.990',
  url: 'https://www.nexorecursos.com/cart/52544692879636:1',
  highlight: true,
  features: ['Todo lo del Plan Esencial', '+ Sistema Lashista de Élite (4 módulos)', '+ Ingeniería de postura y velocidad']
}];
export function PricingSelector({
  variant = 'light'
}: {
  variant?: 'light' | 'cream';
}) {
  const [selectedId, setSelectedId] = useState<'essential' | 'elite'>('elite');
  const selected = PLANS.find(p => p.id === selectedId) || PLANS[1];
  const cardBg = variant === 'cream' ? 'bg-white' : 'bg-white';
  const surfaceBg = variant === 'cream' ? 'bg-[#FAF6F0]' : 'bg-[#FAF6F0]';
  return <div className={`${cardBg} border border-[#E8D5C4] rounded-2xl md:rounded-3xl p-4 sm:p-6 md:p-8 shadow-xl max-w-3xl mx-auto`} data-id="element-32">
      {/* Plan selector — both visible at once */}
      <div className="grid grid-cols-2 gap-2 sm:gap-3 mb-5 md:mb-6" data-id="element-33">
        {PLANS.map(p => {
        const isSelected = selectedId === p.id;
        return <button key={p.id} type="button" onClick={() => setSelectedId(p.id)} aria-pressed={isSelected} className={`relative text-left rounded-xl md:rounded-2xl p-3 sm:p-4 transition-all active:scale-[0.98] ${isSelected ? 'bg-[#5A2A3D] border-2 border-[#5A2A3D] shadow-lg' : `${surfaceBg} border-2 border-[#E8D5C4] hover:border-[#B8956A]`}`} data-id="element-34">
              {p.badge && <div className={`absolute -top-2.5 left-1/2 -translate-x-1/2 px-2.5 py-0.5 rounded-full text-[9px] sm:text-[10px] font-bold uppercase tracking-[0.18em] whitespace-nowrap shadow-md ${isSelected ? 'bg-[#B8956A] text-white' : 'bg-[#B8956A] text-white'}`} data-id="element-35">
                  {p.badge}
                </div>}

              {/* Radio indicator */}
              <div className="flex items-start gap-2" data-id="element-36">
                <div className={`mt-0.5 w-4 h-4 sm:w-5 sm:h-5 rounded-full border-2 shrink-0 flex items-center justify-center ${isSelected ? 'border-[#B8956A] bg-[#B8956A]' : 'border-[#B8956A]/50'}`} data-id="element-37">
                  {isSelected && <div className="w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full bg-white" data-id="element-38" />}
                </div>
                <div className="flex-1 min-w-0" data-id="element-39">
                  <div className={`text-[9px] sm:text-[10px] tracking-[0.2em] font-bold uppercase mb-1 ${isSelected ? 'text-[#E8D5C4]' : 'text-[#B8956A]'}`} data-id="element-40">
                    {p.label}
                  </div>
                  <div className={`text-sm sm:text-base font-bold leading-tight mb-1.5 ${isSelected ? 'text-white' : 'text-[#2D1A22]'}`} style={{
                fontFamily: "'DM Serif Display', serif"
              }} data-id="element-41">
                    {p.title}
                  </div>
                  <div className="flex items-baseline gap-1.5 flex-wrap" data-id="element-42">
                    <span className={`text-xs line-through ${isSelected ? 'text-[#E8D5C4]/70' : 'text-[#5A4A4F]/50'}`} data-id="element-43">
                      {p.oldPrice}
                    </span>
                    <span className={`text-lg sm:text-xl font-bold ${isSelected ? 'text-white' : 'text-[#2D1A22]'}`} style={{
                  fontFamily: "'DM Serif Display', serif"
                }} data-id="element-44">
                      {p.price}
                    </span>
                  </div>
                </div>
              </div>
            </button>;
      })}
      </div>

      {/* Selected plan details */}
      <div className="bg-[#FAF6F0] border border-[#E8D5C4] rounded-xl md:rounded-2xl p-4 md:p-5 mb-5 md:mb-6" data-id="element-45">
        <div className="text-[10px] tracking-[0.2em] text-[#B8956A] font-bold uppercase mb-2" data-id="element-46">
          Incluye en {selected.label}:
        </div>
        <ul className="space-y-1.5" data-id="element-47">
          {selected.features.map((f, i) => <li key={i} className="flex items-start gap-2 text-sm text-[#2D1A22]" data-id="element-48">
              <span className="text-[#B8956A] mt-0.5 shrink-0" data-id="element-49">✓</span>
              <span className="font-medium" data-id="element-50">{f}</span>
            </li>)}
        </ul>
      </div>

      {/* Single dynamic CTA */}
      <a href={selected.url} target="_blank" rel="noopener noreferrer" key={selected.id} className="animate-pulse-glow w-full py-4 md:py-5 rounded-full bg-[#5A2A3D] hover:bg-[#6B3D4F] text-white font-bold text-sm md:text-base transition-all active:scale-95 text-center block shadow-lg tracking-wider uppercase" data-id="element-51">
        → Comprar {selected.title} · {selected.price}
      </a>

      <div className="flex flex-wrap justify-center items-center gap-2 sm:gap-3 mt-4 text-[11px] sm:text-xs font-medium text-[#5A4A4F]" data-id="element-52">
        <span data-id="element-53">🛡️ Garantía 30 días</span>
        <span className="text-[#E8D5C4]" data-id="element-54">|</span>
        <span data-id="element-55">🔒 Pago seguro</span>
        <span className="text-[#E8D5C4]" data-id="element-56">|</span>
        <span data-id="element-57">💳 Mercado Pago</span>
      </div>
    </div>;
}